var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7982 6.92337V34.4237C25.7982 34.7424 25.54 35.0006 25.2212 35.0006H9.16336C8.8446 35.0006 8.58643 34.7424 8.58643 34.4237V6.92337C8.58643 6.60461 8.8446 6.34644 9.16336 6.34644H25.2212C25.54 6.34644 25.7982 6.60461 25.7982 6.92337Z",
    fill: "#FCA71F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5674 5.39108C26.5674 5.91945 26.2145 6.34734 25.7794 6.34734H8.70132C8.26622 6.34734 7.91333 5.91897 7.91333 5.39108V1.967C7.91333 1.43863 8.26622 1.01074 8.70132 1.01074H25.7789C26.214 1.01074 26.5669 1.43911 26.5669 1.967V5.39108H26.5674Z",
    fill: "#E7E5E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5291 5.01426C27.5291 4.76714 27.2363 4.56714 26.8752 4.56714H7.65385C7.29279 4.56714 7 4.76714 7 5.01426V6.7162C7 6.96332 7.29279 7.16332 7.65385 7.16332H26.8752C27.2363 7.16332 27.5291 6.96332 27.5291 6.7162V5.01426Z",
    fill: "#E7E5E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8463 1.47117C25.8463 1.69425 25.4968 1.87502 25.066 1.87502H9.51101C9.07976 1.87502 8.73071 1.69425 8.73071 1.47117V0.40385C8.73071 0.180771 9.08024 0 9.51101 0H25.0655C25.4968 0 25.8458 0.180771 25.8458 0.40385V1.47117H25.8463Z",
    fill: "#E7E5E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5772 6.39453H7V7.98109H27.5772V6.39453Z",
    fill: "#FCA71F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25957 1.00928H8.73071V4.56701H9.25957V1.00928Z",
    fill: "#F9F9F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3653 1.0083H9.83643V4.56603H10.3653V1.0083Z",
    fill: "#F9F9F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4712 1.0083H10.9424V4.56603H11.4712V1.0083Z",
    fill: "#F9F9F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5769 1.0083H12.0481V4.56603H12.5769V1.0083Z",
    fill: "#F9F9F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6827 1.0083H13.1538V4.56603H13.6827V1.0083Z",
    fill: "#F9F9F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7886 1.0083H14.2598V4.56603H14.7886V1.0083Z",
    fill: "#F9F9F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8946 1.0083H15.3657V4.56603H15.8946V1.0083Z",
    fill: "#F9F9F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.0083H16.4712V4.56603H17V1.0083Z",
    fill: "#F9F9F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1058 1.0083H17.5769V4.56603H18.1058V1.0083Z",
    fill: "#F9F9F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2117 1.0083H18.6829V4.56603H19.2117V1.0083Z",
    fill: "#F9F9F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3174 1.0083H19.7886V4.56603H20.3174V1.0083Z",
    fill: "#F9F9F9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4231 1.0083H20.8943V4.56603H21.4231V1.0083Z",
    fill: "#F9F9F9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5289 1.0083H22V4.56603H22.5289V1.0083Z",
    fill: "#F9F9F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6348 1.0083H23.106V4.56603H23.6348V1.0083Z",
    fill: "#F9F9F9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7405 1.0083H24.2117V4.56603H24.7405V1.0083Z",
    fill: "#F9F9F9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8465 1.0083H25.3176V4.56603H25.8465V1.0083Z",
    fill: "#F9F9F9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0289 7.98169H10.6538V33.5108H15.0289V7.98169Z",
    fill: "#FFBA57"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5965 10.0952H9.98096V31.2974H24.5965V10.0952Z",
    fill: "#EFEFEF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0289 10.0952H10.6538V31.2974H15.0289V10.0952Z",
    fill: "#F7F7F7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.cb4c5ca2b63066392514349a6a421186.svg";
export { ForwardRef as ReactComponent };